import { useEffect, useState } from 'react';
import api from '../api';
import { useApp } from '../App';
import BackButton from '../components/BackButton';
import { useI18n } from '../i18n/index.jsx';

const TYPES = [
  { id: 'b2b_services', name: 'B2B услуги' },
  { id: 'rent', name: 'Аренда' },
  { id: 'sale', name: 'Продажа' },
  { id: 'purchase', name: 'Покупка' },
  { id: 'contractor', name: 'Подряд' },
  { id: 'custom', name: 'Другое' },
];

export default function PartnerContracts() {
  const { currentCompany } = useApp();
  const { t } = useI18n();
  const [contracts, setContracts] = useState([]);
  const [counterparties, setCounterparties] = useState([]);
  const [msg, setMsg] = useState('');
  const [file, setFile] = useState(null);
  const [form, setForm] = useState({
    counterparty_id: '',
    contract_type: 'b2b_services',
    subject: '',
    description: '',
    start_date: '',
    end_date: '',
    place: '',
    amount: '',
    currency: 'PLN',
    payment_terms: '',
  });

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const [ct, cp] = await Promise.all([
        api.get('/partner-contracts'),
        api.get('/counterparties'),
      ]);
      setContracts(ct.data || []);
      setCounterparties(cp.data || []);
    } catch (e) {
      setMsg(e.userMessage || e.response?.data?.detail || 'Ошибка');
    }
  }

  async function create() {
    if (!currentCompany?.id) { setMsg('Выберите компанию'); return; }
    if (!form.counterparty_id) { setMsg('Выберите контрагента'); return; }
    try {
      await api.post('/partner-contracts', {
        ...form,
        company_id: currentCompany.id,
        counterparty_id: Number(form.counterparty_id),
        amount: form.amount ? Number(form.amount) : null,
        start_date: form.start_date || null,
        end_date: form.end_date || null,
      });
      setMsg('✅ Договор создан и отправлен на верификацию');
      setForm({ counterparty_id: '', contract_type: 'b2b_services', subject: '', description: '', start_date: '', end_date: '', place: '', amount: '', currency: 'PLN', payment_terms: '' });
      load();
    } catch (e) {
      setMsg(e.userMessage || e.response?.data?.detail || 'Ошибка');
    }
  }

  async function upload() {
    if (!currentCompany?.id) { setMsg('Выберите компанию'); return; }
    if (!form.counterparty_id) { setMsg('Выберите контрагента'); return; }
    if (!file) { setMsg('Выберите PDF'); return; }
    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('company_id', currentCompany.id);
      fd.append('counterparty_id', form.counterparty_id);
      fd.append('contract_type', form.contract_type || 'custom');
      fd.append('subject', form.subject || '');
      fd.append('description', form.description || '');
      await api.post('/partner-contracts/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setMsg('✅ Договор загружен и отправлен на верификацию');
      setFile(null);
      load();
    } catch (e) {
      setMsg(e.userMessage || e.response?.data?.detail || 'Ошибка');
    }
  }

  async function send(id) {
    try {
      await api.post(`/partner-contracts/${id}/send`);
      setMsg('📧 Отправлено контрагенту');
      load();
    } catch (e) {
      setMsg(e.userMessage || e.response?.data?.detail || 'Ошибка');
    }
  }

  function pdfUrl(id) {
    return `${api.defaults.baseURL}/partner-contracts/${id}/pdf`;
  }

  return (
    <div className="page">
      <BackButton />
      <h1>📑 Договоры с контрагентами</h1>
      {msg && <div className="message">{msg}</div>}

      <div style={{ background: 'var(--card)', borderRadius: 16, padding: 18, marginBottom: 16, border: '1px solid rgba(255,255,255,0.06)' }}>
        <div style={{ fontWeight: 700, marginBottom: 10 }}>Создать договор (AI‑шаблон)</div>
        <div className="form">
          <div className="field">
            <label>Контрагент</label>
            <select value={form.counterparty_id} onChange={e => setForm({ ...form, counterparty_id: e.target.value })}>
              <option value="">Выберите контрагента</option>
              {counterparties.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div className="field">
            <label>Тип договора</label>
            <select value={form.contract_type} onChange={e => setForm({ ...form, contract_type: e.target.value })}>
              {TYPES.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
            </select>
          </div>
          <div className="field">
            <label>Тема / предмет</label>
            <input placeholder="Коротко о договоре" value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })} />
          </div>
          <div className="field">
            <label>{t('common.description')}</label>
            <textarea placeholder="Что именно делаем, объём, условия" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
          </div>
          <div className="field" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div>
              <label>Начало</label>
              <input type="date" value={form.start_date} onChange={e => setForm({ ...form, start_date: e.target.value })} />
            </div>
            <div>
              <label>Окончание</label>
              <input type="date" value={form.end_date} onChange={e => setForm({ ...form, end_date: e.target.value })} />
            </div>
          </div>
          <div className="field">
            <label>Место заключения</label>
            <input placeholder="Город" value={form.place} onChange={e => setForm({ ...form, place: e.target.value })} />
          </div>
          <div className="field" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div>
              <label>{t('common.amount')}</label>
              <input placeholder="0.00" value={form.amount} onChange={e => setForm({ ...form, amount: e.target.value })} />
            </div>
            <div>
              <label>Валюта</label>
              <input placeholder="PLN" value={form.currency} onChange={e => setForm({ ...form, currency: e.target.value })} />
            </div>
          </div>
          <div className="field">
            <label>Условия оплаты</label>
            <input placeholder="Напр.: 14 дней после подписания" value={form.payment_terms} onChange={e => setForm({ ...form, payment_terms: e.target.value })} />
          </div>
        </div>
        <button className="btn btn-primary" style={{ width: '100%' }} onClick={create}>Сгенерировать</button>

        <div style={{ marginTop: 14, borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: 14 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Или загрузить PDF</div>
          <div className="field">
            <input type="file" accept="application/pdf" onChange={e => setFile(e.target.files?.[0])} />
          </div>
          <button className="btn" style={{ width: '100%' }} onClick={upload}>Загрузить</button>
        </div>
      </div>

      {contracts.length === 0 ? (
        <div className="empty">Договоров пока нет</div>
      ) : (
        <div className="list">
          {contracts.map(c => (
            <div key={c.id} className="list-item" style={{ alignItems: 'flex-start' }}>
              <div className="list-main">
                <div className="list-title">{c.contract_type}</div>
                <div className="list-sub">Статус: {c.status}</div>
                {c.subject && <div className="list-sub">{c.subject}</div>}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <a className="btn btn-small" href={pdfUrl(c.id)} target="_blank" rel="noreferrer">PDF</a>
                {c.status === 'approved' && <button className="btn btn-small" onClick={() => send(c.id)}>📧</button>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
